
import { Alert } from 'antd';

import history from '../../history';

const React = require('react')



export default  (props) =>{
    console.log('sv got error Tag errob************')
    console.log(props)
    //const history = useHistory();
    const {closecbParent,svCustomerId} = props
    console.log('sv got error Tag svCustomerId************')
    console.log(svCustomerId)
    const errdefault = {
        "timestamp": "2015-08-23T02:27:18.038+0000",
        "status": 500,
        "error": "Default Error",
        "message": "500 null",
        "path": "/kk/svaddressDetailPost"
    }
    

    let sm =null
    if(props.errob){
        sm = JSON.stringify(props.errob)
    }else{
        sm  = JSON.stringify(errdefault)
    }

    const closeMe = (e)=>{
        console.log('close calles****** history start svCustomerId******')
        console.log(history)
        console.log('close calles****** history end  svCustomerId******')
        console.log(svCustomerId)
       // history.push(`/myaccountSV/9/myaddressList`); 
       // history.goBack();
       // history.goBack();
        //history.go(-1);

       // history.push(`/myaccountSV/${svcustomerId}/myaddressList`)
        
        if (closecbParent){
            closecbParent()
          // history.replace(`/myaccountSV/9/myaddressList`); 
          // history.goBack(); 
        }else{  

           //this works but nor all component might pass svcustomerId in props
           // history.push(`/myaccountSV/9/myaddressList`); 
           history.push(`/svlogin`); 
           //  history.goBack(); 
        }
        
      
    }
    return (
        <div>
           
   
    <Alert  closable onClose={closeMe} message={sm} type="error" />
  
            
        </div>
    )

}